export function FormatCurrency(value, currency, locale) {
    if (currency === void 0) { currency = 'USD'; }
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 0 }).format(value);
}
export function FormatNumber(value) {
    return new Intl.NumberFormat().format(value);
}
//# sourceMappingURL=IntlUtils.js.map